// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-color: var(--mi-secondary-color-1);
}

.welcome-page-wrap {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: 100%;
  height: 100%;
}
.welcome-page-wrap .action-buttons-container {
  grid-row: 1;
  grid-column: 1;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: min-content auto;
  row-gap: 50px;
  justify-content: center;
  padding: 170px 25px 55px 25px;
}
.welcome-page-wrap .action-buttons-container ion-img.myao-logo {
  grid-row: 1;
  grid-column: 1;
  width: 160px;
}
.welcome-page-wrap .action-buttons-container app-auth-buttons {
  grid-row: 2;
  grid-column: 1;
}
.welcome-page-wrap .slides-wrap {
  grid-row: 1;
  grid-column: 2;
  overflow: hidden;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper {
  width: 100%;
  height: 100%;
  max-height: 100vh;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide .slide-container {
  width: 100%;
  height: 100%;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide .slide-container .text-container {
  position: absolute;
  top: 40%;
  left: 8%;
  width: 45%;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide .slide-container .text-container .text {
  color: var(--mi-white-color);
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide .slide-container .text-container .text.headline {
  font-size: var(--font-size-extra-large-4);
  line-height: var(--font-line-height-extra-large-4);
  font-weight: var(--font-weight-semi-bold);
  font-style: normal;
}
.welcome-page-wrap .slides-wrap .swiper-wrapper .swiper-slide .slide-container .text-container .text.subheadline {
  margin-top: 30px;
  font-size: var(--font-size-large-1);
  line-height: var(--font-line-height-large);
  font-weight: var(--font-weight-regular);
  font-style: normal;
}
.welcome-page-wrap .slides-wrap .swiper-pagination {
  bottom: 62px;
  z-index: 1000;
}
.welcome-page-wrap .slides-wrap .swiper-pagination .swiper-pagination-bullet {
  border: 1px solid var(--mi-white-color);
  background: transparent;
  opacity: 100;
}
.welcome-page-wrap .slides-wrap .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: var(--mi-white-color);
}

.welcome-page-img-background {
  width: 100%;
  height: 100%;
}

.auth-welcome-responsive {
  display: none;
  height: 100%;
}

@media only screen and (max-width: 600px) {
  .welcome-page-wrap {
    display: block;
    height: auto;
  }
  .auth-welcome-responsive {
    display: block;
  }
  .auth-page-container {
    display: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
